/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PatientFamilyPharmacistTypename = "PatientFamilyPharmacist" as const;

/**
 *
 * @export
 * @interface PatientFamilyPharmacist
 */
export interface PatientFamilyPharmacist {
  /**
   *
   * @type {string}
   * @memberof PatientFamilyPharmacist
   */
  contact?: string;
  /**
   *
   * @type {Date}
   * @memberof PatientFamilyPharmacist
   */
  lastUpdatedTime?: string;
  /**
   *
   * @type {string}
   * @memberof PatientFamilyPharmacist
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof PatientFamilyPharmacist
   */
  pharmacyName?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PatientFamilyPharmacist
   */
  readonly __typename?: string;
}

export function PatientFamilyPharmacistFromJSON(json: any): PatientFamilyPharmacist {
  return PatientFamilyPharmacistFromJSONTyped(json, false);
}

export function PatientFamilyPharmacistFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientFamilyPharmacist {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PatientFamilyPharmacistTypename,

    contact: !exists(json, "contact") ? undefined : json["contact"],
    lastUpdatedTime:
      !exists(json, "last_updated_time") ||
      (typeof json["last_updated_time"] === "string" && json["last_updated_time"].substring(0, 4) === "0001")
        ? undefined
        : json["last_updated_time"],
    name: !exists(json, "name") ? undefined : json["name"],
    pharmacyName: !exists(json, "pharmacy_name") ? undefined : json["pharmacy_name"],
  };
}

export function PatientFamilyPharmacistToJSON(object?: PatientFamilyPharmacist | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    contact: value.contact,
    last_updated_time: value.lastUpdatedTime === undefined ? undefined : tzDate(value.lastUpdatedTime).format(),
    name: value.name,
    pharmacy_name: value.pharmacyName,
  };
}
